//src/components/ProductItem.js

import React, { useContext } from "react";
import { itemContext } from "../context/ItemContext";

const ProductItem = ({ product }) => {
  const { addToCart } = useContext(itemContext);

  const handleAddToCart = () => {
    if (!product || typeof product.price !== "number") {
      console.error("Invalid product or product price");
      return;
    }
    addToCart(product);
  };

  if (!product) {
    console.error("ProductItem received an undefined product");
    return null;
  }

  if (!product.image || !product.name) {
    console.error("Product image or name is missing for product:", product);
    return null;
  }

  return (
    <div className="product-card">
      <img className="product-image" src={product.image} alt={product.name} />
      <div className="product-details">
        <h3 style={{ fontWeight: "700" }}>{product.name}</h3>
        <p style={{ fontWeight: "300" }}>{product.description}</p>
        <p style={{ fontWeight: "500" }}>Price: {product.price}</p>
        <button onClick={handleAddToCart}> Add to cart</button>
      </div>
    </div>
  );
};

export default ProductItem;
